import revertEndpoints from '../config/revert-endpoints.json';

export const shouldShowRevert = (revert_uri) => {
    if (!revert_uri) return false;
    return revertEndpoints.some(endpoint => endpoint.revert_uri === revert_uri);
};

export const getProcessId = (revert_uri) => {
    if (!revert_uri) return null;
    const endpoint = revertEndpoints.find(endpoint => endpoint.revert_uri === revert_uri);
    return endpoint ? endpoint.process_id : null;
};

export const getApiUri = (revert_uri) => {
    if (!revert_uri) return null;
    const endpoint = revertEndpoints.find(endpoint => endpoint.revert_uri === revert_uri);
    return endpoint ? endpoint.api_uri : null;
};

export const getRevertEndpoint = (revert_uri) => {
    if (!revert_uri) return null;
    const endpoint = revertEndpoints.find(endpoint => endpoint.revert_uri === revert_uri);
    return endpoint ? endpoint.revert_uri : null;
};

export const getRevertTitle = (pageUrl) => {
    const endpoint = revertEndpoints[pageUrl];
    return endpoint?.title || 'Geri Al';
}; 